import React from 'react';
import { deriveCameraDisplayStatus } from '../../utils/cameraHealth';
import { formatInTimezone } from '../../utils/formatInTimezone';
import { countRu, ATTEMPT_FORMS } from '../../utils/pluralRu';

const RETRY_STATES = ['RETRYING', 'RETRY_WAIT'];

const CameraHealthBadge = ({ camera, compact = false }) => {
  const { text, color } = deriveCameraDisplayStatus(camera);
  const health = camera?.health_summary;
  const cs = (health?.connection_status || '').toUpperCase();
  const inRetry = RETRY_STATES.includes(cs) && health?.desired_running !== false;

  const retryCount = health?.retry_count;
  const nextRetry = health?.next_retry_at
    ? formatInTimezone(health.next_retry_at, camera?.display_timezone)
    : null;

  const tooltip = inRetry
    ? [
        retryCount != null ? countRu(retryCount, ATTEMPT_FORMS) : null,
        nextRetry ? `следующая ${nextRetry}` : null,
      ].filter(Boolean).join(' · ') || undefined
    : undefined;

  return (
    <span className="camera-health-badge">
      <span className={`badge bg-${color}`} title={tooltip}>{text}</span>
      {!compact && inRetry && retryCount != null && (
        <span className="camera-health-retry small text-muted d-block mt-1" title={tooltip}>
          {countRu(retryCount, ATTEMPT_FORMS)}{nextRetry ? ` · следующая ${nextRetry}` : ''}
        </span>
      )}
    </span>
  );
};

export default CameraHealthBadge;
